<template lang="pug">
fragment
  FormTextInput(:rules="{ required: true }", name="映像制作を何年前からはじめましたか？" title="映像制作を何年前から<br class='pc'>はじめましたか？" label="video_production_years" v-model="video_production_years" type="text" placeholder="〇〇年")
  dt.required
    | 映像製作工程で業務経験があるもの（複数可）
  dd
    validation-provider(rules="required" name="映像製作工程で業務経験があるもの" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      div(:class="{ 'checkbox-error': invalid && validated }")
        .v-checkbox(v-for="(vpp, i) in videoProductionProcesses")
          input(type="checkbox" v-model="video_production_process" :value="vpp" :id="`videoProductionProcess-${i}`")
          label(:for="`videoProductionProcess-${i}`")
            | {{ vpp }}
          template(v-if="vpp === 'その他'")
            validation-provider(:rules="{ required: isOtherRequired(`videoProductionProcess-${i}`) }" name="その他工程" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
              .error-message(v-if="errors[0]" v-html="errors[0]")
              input(type="text" v-model="video_production_process_other" :class="{ error: invalid && validated }")
  dt.required
    | 所有しているメインカメラのブランドと機種名を教えてください
  dd
    validation-provider(rules="required" name="所有しているメインカメラのブランド" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      .v-selectbox(style="margin-bottom: 5px")
        select(v-model="main_camera" :class="{ error: invalid && validated }")
          option(:value="null" :disabled="true")
            | 選択してください
          option(v-for="camera in cameras" :value="camera")
            | {{ camera }}
    validation-provider(:rules="{ required: main_camera !== '持っていない' }" name="機種名" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      input(type="text" v-model="main_camera_model" placeholder="機種名" :class="{ error: invalid && validated }")
  dt.required
    | 所有しているサブカメラのブランドと機種名を教えてください
  dd
    validation-provider(rules="required" name="所有しているサブカメラのブランド" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      .v-selectbox(style="margin-bottom: 5px")
        select(v-model="sub_camera" :class="{ error: invalid && validated }")
          option(:value="null" :disabled="true")
            | 選択してください
          option(v-for="camera in cameras" :value="camera")
            | {{ camera }}
    validation-provider(:rules="{ required: sub_camera !== '持っていない' }"  name="機種名" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      input(type="text" v-model="sub_camera_model" placeholder="機種名" :class="{ error: invalid && validated }")
  FormTextarea(rules="required" name="所有しているカメラ以外の機材を教えてください" label="other_equipment" v-model="other_equipment" type="text")
  dt.required
    | よく使うレンズのブランドとレンズ名を教えてください（複数可）
  dd
    validation-provider(rules="required" name="よく使うレンズのブランド" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      div(:class="{ 'checkbox-error': invalid && validated }")
        .v-checkbox(v-for="(brand, i) in lensBrands")
          input(type="checkbox" v-model="lens_brands" :value="brand" :id="`lensBrand-${i}`")
          label(:for="`lensBrand-${i}`")
            | {{ brand }}
          template(v-if="brand !== '持っていない'")
            validation-provider(:rules="{ required: isOtherRequired(`lensBrand-${i}`) }" name="レンズ名" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
              .error-message(v-if="errors[0]" v-html="errors[0]")
              input(type="text" v-model="tmpLensNames[brand]" placeholder="レンズ名" :class="{ error: invalid && validated }")
  dt.required
    | 使用しているメインPCのブランドを教えてください
  dd
    validation-provider(rules="required" name="使用しているメインPCのブランド" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      .v-selectbox(style="margin-bottom: 5px")
        select(v-model="main_pc_brand" :class="{ error: invalid && validated }")
          option(:value="null" :disabled="true")
            | 選択してください
          option(v-for="brand in pcBrands" :value="brand")
            | {{ brand }}
    validation-provider(:rules="{ required: main_pc_brand === 'その他' }" name="その他のブランド" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      input(type="text" v-model="main_pc_brand_other" placeholder="その他のブランド" :class="{ error: invalid && validated }")
  dt.required
    | 使用しているメインPCの価格帯を教えてください
  dd
    validation-provider(rules="required" name="使用しているメインPCの価格帯" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      .v-selectbox(style="margin-bottom: 5px")
        select(v-model="main_pc_price" :class="{ error: invalid && validated }")
          option(:value="null" :disabled="true")
            | 選択してください
          option(v-for="price in pcPrices" :value="price")
            | {{ price }}
  dt.required
    | 普段使用している制作ツールを教えてください（複数可）
  dd
    validation-provider(rules="required" name="普段使用している制作ツール" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      div(:class="{ 'checkbox-error': invalid && validated }")
        .v-checkbox(v-for="(productionTool, i) in productionTools")
          input(type="checkbox" v-model="frequently_used_production_tools" :value="productionTool" :id="`frequentlyUsedProductionTools-${i}`")
          label(:for="`frequentlyUsedProductionTools-${i}`")
            | {{ productionTool }}
          template(v-if="productionTool === 'その他'")
            validation-provider(:rules="{ required: isOtherRequired(`frequentlyUsedProductionTools-${i}`) }" name="その他のツール" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
              .error-message(v-if="errors[0]" v-html="errors[0]")
              input(type="text" v-model="frequently_used_production_tools_other" :class="{ error: invalid && validated }")
  dt.required
    | 今後使ってみたい制作ツールを教えてください（複数可）
  dd
    validation-provider(rules="required" name="今後使ってみたい制作ツール" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      .v-checkbox(v-for="(productionTool, i) in productionTools.concat(['特になし'])")
        input(type="checkbox" v-model="want_to_use_production_tools" :value="productionTool" :id="`wantToUseProductionTools-${i}`")
        label(:for="`wantToUseProductionTools-${i}`")
          | {{ productionTool }}
        template(v-if="productionTool === 'その他'")
          validation-provider(:rules="{ required: isOtherRequired(`wantToUseProductionTools-${i}`) }" name="その他のツール" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
            .error-message(v-if="errors[0]" v-html="errors[0]")
            input(type="text" v-model="want_to_use_production_tools_other" :class="{ error: invalid && validated }")
  dt.required
    | メインで制作している映像のジャンルを教えてください
  dd
    validation-provider(rules="required" name="メインで制作している映像のジャンル" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      .v-selectbox(style="margin-bottom: 5px")
        select(v-model="main_video_genre" :class="{ error: invalid && validated }")
          option(:value="null" :disabled="true")
            | 選択してください
          option(v-for="genre in videoGenres" :value="genre")
            | {{ genre }}
    validation-provider(:rules="{ required: main_video_genre === 'その他' }" name="その他のジャンル" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      input(type="text" v-model="main_video_genre_other" placeholder="その他のジャンル" :class="{ error: invalid && validated }")
  dt.required
    | 今後制作したい映像のジャンルを1つ教えてください
  dd
    validation-provider(rules="required" name="今後制作したい映像のジャンル" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      .v-selectbox(style="margin-bottom: 5px")
        select(v-model="want_video_genre" :class="{ error: invalid && validated }")
          option(:value="null" :disabled="true")
            | 選択してください
          option(v-for="genre in videoGenres" :value="genre")
            | {{ genre }}
    validation-provider(:rules="{ required: want_video_genre === 'その他' }" name="その他ジャンル" v-slot="{ errors, invalid, validated }")
      .error-message(v-html="errors[0]")
      input(type="text" v-model="want_video_genre_other" placeholder="その他ジャンル" :class="{ error: invalid && validated }")
  dt.required
    | 機材はどこで購入することが多いですか？（複数可）
  dd
    validation-provider(rules="required" name="機材はどこで購入することが多いですか？" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      div(:class="{ 'checkbox-error': invalid && validated }")
        | 【実店舗】
        .v-checkbox(v-for="(realStore, i) in realStores")
          input(type="checkbox" v-model="where_to_buy_equipment" :value="realStore" :id="`whereToBuyEquipment-R-${i}`")
          label(:for="`whereToBuyEquipment-R-${i}`")
            | {{ realStore }}
          template(v-if="realStore === 'その他の実店舗'")
            validation-provider(:rules="{ required: isOtherRequired(`whereToBuyEquipment-R-${i}`) }" name="その他の実店舗" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
              .error-message(v-if="errors[0]" v-html="errors[0]")
              input(type="text" v-model="where_to_buy_equipment_real_other" :class="{ error: invalid && validated }")
        br
        | 【オンラインショップ】
        .v-checkbox(v-for="(ecStore, i) in ecStores")
          input(type="checkbox" v-model="where_to_buy_equipment" :value="ecStore" :id="`whereToBuyEquipment-E-${i}`")
          label(:for="`whereToBuyEquipment-E-${i}`")
            | {{ ecStore }}
          template(v-if="ecStore === 'その他のオンラインショップ'")
            validation-provider(:rules="{ required: isOtherRequired(`whereToBuyEquipment-E-${i}`) }" name="その他のオンラインショップ" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
              .error-message(v-if="errors[0]" v-html="errors[0]")
              input(type="text" v-model="where_to_buy_equipment_online_other" :class="{ error: invalid && validated }")
  dt.required
    | 映像クリエイターとして活動する上で課題と感じることはありますか？（複数可）
  dd
    validation-provider(rules="required" name="映像クリエイターとして活動する上で課題と感じること" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      div(:class="{ 'checkbox-error': invalid && validated }")
        .v-checkbox(v-for="(issue, i) in creatorIssues")
          input(type="checkbox" v-model="issues" :value="issue" :id="`issue-${i}`")
          label(:for="`issue-${i}`")
            | {{ issue }}
          template(v-if="issue === 'その他'")
            validation-provider(:rules="{ required: isOtherRequired(`issue-${i}`) }" name="その他の課題" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
              .error-message(v-if="errors[0]" v-html="errors[0]")
              input(type="text" v-model="issues_other" :class="{ error: invalid && validated }")
  dt.required
    | オンラインでどのような映像制作者向けのコンテンツを視聴したいと思いますか？（複数可）
  dd
    validation-provider(rules="required" name="オンラインで視聴したい映像制作者向けのコンテンツ" v-slot="{ errors, invalid, validated }")
      .error-message(v-if="errors[0]" v-html="errors[0]")
      div(:class="{ 'checkbox-error': invalid && validated }")
        .v-checkbox(v-for="(content, i) in onlineContents")
          input(type="checkbox" v-model="online_contents" :value="content" :id="`onlineContent-${i}`")
          label(:for="`onlineContent-${i}`")
            | {{ content }}
          template(v-if="content === 'その他'")
            validation-provider(:rules="{ required: isOtherRequired(`onlineContent-${i}`) }" name="その他のコンテンツ" v-slot="{ errors, invalid, validated }" tag="div" class="v-fa")
              .error-message(v-if="errors[0]" v-html="errors[0]")
              input(type="text" v-model="online_contents_other" :class="{ error: invalid && validated }")
</template>

<script>
import { mapGetters } from 'vuex'
import { Fragment } from 'vue-fragment'
import FormTextInput from '~/components/FormTextInput'
import FormTextarea from '~/components/FormTextarea'

const VIDEO_PRODUCTION_PROCESSES = [
  '制作進行',
  '撮影',
  '撮影アシスタント',
  '企画',
  '動画編集',
  'モーショングラフィックス',
  '3DCG',
  'カラーグレーディング',
  'その他'
]
const CAMERAS = [
  'ソニー',
  'キャノン',
  'パナソニック LUMIX Gシリーズ',
  'パナソニック LUMIX Sシリーズ',
  'パナソニック 上記以外の製品',
  'ニコン Zシリーズ',
  'ニコン 上記以外の製品',
  'ブラックマジック',
  'OM SYSTEM(オリンパス)',
  'フジフイルム',
  'DJI',
  'GoPro',
  'その他',
  '持っていない'
]
const LENS_BRANDS = [
  'Canon',
  'Nikon',
  'Sony',
  'OM SYSTEM(OLYMPUS)',
  'Panasonic',
  'FUJIFILM',
  'PENTAX',
  'Sigma',
  'Tamron',
  'Leica',
  'Carl Zeiss',
  'Cosina',
  'Tokina',
  'その他',
  '持っていない'
]
const PC_BRANDS = [
  'Apple',
  'ASUS',
  'BTOメーカー製',
  'DELL',
  'dynabook',
  'HP',
  'Microsoft',
  'msi',
  'NEC',
  'VAIO',
  'パソコン工房',
  'パナソニック',
  '富士通',
  'マウスコンピューター',
  'レノボ',
  'その他',
  'PCを持っていない'
]
const PC_PRICES = [
  '～15万円 未満',
  '15万～20万円 未満',
  '20万～30万円 未満',
  '30万～50万円 未満',
  '50万～70万円 未満',
  '70万円以上',
  'PCを持っていない'
]
const PRODUCTION_TOOLS = [
  'Premiere Pro',
  'After Effects',
  'DaVinci Resolve',
  'Final Cut Pro',
  'Photoshop',
  'Cinema 4D',
  'Maya',
  'Adobe Premiere Rush',
  'Illustrator',
  'Indesign',
  'Adobe Audition',
  'iMovie',
  'EDIUS Pro',
  'その他'
]
const VIDEO_GENRES = [
  '人物インタビュー',
  'ウェディング',
  'スポーツ',
  '自然／風景',
  'CM・VP',
  'ミュージックビデオ',
  '映画・ショートフィルム',
  'ドキュメンタリー',
  'Vlog',
  'Indesign',
  'Tiktok',
  'YouTube向けコンテンツ',
  '企業内での動画制作（インハウス動画）',
  'VRコンテンツ',
  'その他'
]
const REAL_STORES = [
  'ヨドバシカメラ',
  'ビックカメラ',
  'ヤマダ電機',
  'カメラのキタムラ',
  'システムファイブ ショールーム',
  '銀一 スタジオショップ',
  'フジヤエービック',
  'メーカー直営店舗/ショールーム（DJIストア/ソニーストアなど）',
  'その他の実店舗'
]
const EC_STORES = [
  'アマゾン（Amazon.co.jp）',
  '家電量販店のネットショッピングサイト（ヨドバシ・ドット・コム/ビック・ドット・コムなど）',
  'メルカリ等のフリマアプリ',
  '海外のネットショッピングサイト（B&Hなど）',
  'メーカー直営ネットショッピングサイト（GoProストア、DIJストア、ソニーストアなど）',
  '楽天',
  'プロフェッショナル映像機材販売店のネットショッピングサイト（システムファイブ）',
  'その他のオンラインショップ'
]
const CREATOR_ISSUES = [
  '体系だった学びの場が少ない',
  '最新の情報を収集するのが大変',
  '映像制作だけでは生計を立てるのが困難',
  'フリーランスとして活動したいが仕事がなかなか見つからない',
  'キャリアに関する相談相手がいない',
  '映像制作以外の事務作業が多く、映像制作に集中できない',
  'クライアントのコミュニケーションが大変',
  '拘束時間が長い',
  '一人作業が多く孤独を感じることが多い',
  '映像制作に必要なクリエーターメンバーの募集が困難',
  '撮影に適した機材、プラグインなどの選択が難しい',
  '映像制作に関する相談相手がいない',
  'その他'
]
const ONLINE_CONTENTS = [
  '総合的なワークフロー',
  'カメラワーク',
  '絵コンテ・演出コンテの作り方',
  '制作前の企画について',
  '予算管理について',
  '撮影現場のドキュメントづくり',
  '機材についての細かいノウハウ',
  '編集ソフトの使い方',
  'カラーグレーディング',
  '撮影についての初心者コンテンツ',
  '音響・収録',
  'モーショングラフィックス',
  '3DCG',
  'VFX',
  'VR・AR・メタバース',
  'ライブ配信について',
  'その他'
]
const ENQUETE_ATTRIBUTE = [
  'video_production_years',
  'video_production_process',
  'video_production_process_other',
  'main_camera',
  'main_camera_model',
  'sub_camera',
  'sub_camera_model',
  'other_equipment',
  'lens_brands',
  'lens_names',
  'main_pc_brand',
  'main_pc_brand_other',
  'main_pc_price',
  'frequently_used_production_tools',
  'frequently_used_production_tools_other',
  'want_to_use_production_tools',
  'want_to_use_production_tools_other',
  'main_video_genre',
  'main_video_genre_other',
  'want_video_genre',
  'want_video_genre_other',
  'where_to_buy_equipment',
  'where_to_buy_equipment_real_other',
  'where_to_buy_equipment_online_other',
  'issues',
  'issues_other',
  'online_contents',
  'online_contents_other'
]

export default {
  components: {
    FormTextInput,
    FormTextarea,
    Fragment
  },
  data() {
    return {
      tmpLensNames: {}
    }
  },
  computed: {
    ...mapGetters('billing', ['enquete']),
    videoProductionProcesses() {
      return VIDEO_PRODUCTION_PROCESSES
    },
    cameras() {
      return CAMERAS
    },
    lensBrands() {
      return LENS_BRANDS
    },
    pcBrands() {
      return PC_BRANDS
    },
    pcPrices() {
      return PC_PRICES
    },
    productionTools() {
      return PRODUCTION_TOOLS
    },
    videoGenres() {
      return VIDEO_GENRES
    },
    realStores() {
      return REAL_STORES
    },
    ecStores() {
      return EC_STORES
    },
    creatorIssues() {
      return CREATOR_ISSUES
    },
    onlineContents() {
      return ONLINE_CONTENTS
    }
  },
  watch: {
    lens_brands() {
      this.lens_names = this.lens_brands.map((brand) => {
        return this.tmpLensNames[brand]
      })
    },
    tmpLensNames() {
      this.lens_names = this.lens_brands.map((brand) => {
        return this.tmpLensNames[brand]
      })
    }
  },
  beforeCreate() {
    ENQUETE_ATTRIBUTE.forEach((key) => {
      this.$options.computed = {
        ...this.$options.computed,
        [key]: {
          get() {
            return this.enquete[key]
          },
          set(val) {
            this.$store.commit('billing/updateEnqueteAttributes', {
              attribute: key,
              data: val
            })
          }
        }
      }
    })
  },
  methods: {
    isOtherRequired(id) {
      if (process.browser) {
        const element = document.getElementById(id)
        if (element) {
          return element.checked
        }
      } else {
        return false
      }
    }
  }
}
</script>
